import { OnboardingStep } from '../types';

export abstract class OnboardingStepsService {

    private static readonly orderedSteps: OnboardingStep[] = [ 'week', 'weekday', 'selectAll' ];

    private static getFirstStep(): OnboardingStep {
        return this.orderedSteps[0];
    }

    private static getLastStep(): OnboardingStep {
        return this.orderedSteps[this.orderedSteps.length - 1];
    }

    static isLast(step: OnboardingStep) {
        return step === this.getLastStep();
    }

    static getNextStep(step: OnboardingStep | null): OnboardingStep | null {
        if (step === null) {
            return this.getFirstStep();
        }

        const index = this.orderedSteps.indexOf(step);

        if (index === -1) {
            return null;
        }

        const nextStepIndex = index + 1;

        return this.orderedSteps[nextStepIndex] ?? null;
    }

}
